import { PUBLIC_LANDING_ROUTES, UrlConfig, USER_FACING_PRODUCT_CATEGORIES } from '@/setup/routing/routing'

/** A single link inside the Solutions mega-menu (and its mobile accordion). */
export interface ILandingV3NavItem {
    label: string
    href: string
    /** Optional brand/channel icon (only the "By channel" group uses these). */
    iconSrc?: string
}

/** A titled column in the Solutions mega-menu. */
export interface ILandingV3NavGroup {
    heading: string
    items: ILandingV3NavItem[]
}

const productHref = (productCategory: (typeof USER_FACING_PRODUCT_CATEGORIES)[keyof typeof USER_FACING_PRODUCT_CATEGORIES]) =>
    UrlConfig['/products/[user_facing_product_category]'].getUrl({ productCategory })

/**
 * The lp-v3 Solutions mega-menu, grouped as By channel / By workflow / By use case.
 */
export const SOLUTIONS_GROUPS: ILandingV3NavGroup[] = [
    {
        heading: 'By channel',
        items: [
            { label: 'Meta Ads', href: PUBLIC_LANDING_ROUTES.INTEGRATIONS_META, iconSrc: '/icons/metaads.svg' },
            { label: 'TikTok Ads', href: PUBLIC_LANDING_ROUTES.INTEGRATIONS_TIKTOK, iconSrc: '/icons/tiktokads.svg' },
            { label: 'Google Ads', href: PUBLIC_LANDING_ROUTES.INTEGRATIONS_GOOGLE, iconSrc: '/icons/googleads.svg' },
            { label: 'Shopify Store', href: PUBLIC_LANDING_ROUTES.SHOPIFY_STORE, iconSrc: '/icons/shopify.svg' },
        ],
    },
    {
        heading: 'By workflow',
        items: [
            { label: 'Ad Research', href: PUBLIC_LANDING_ROUTES.AD_RESEARCH },
            { label: 'Creative Strategy', href: PUBLIC_LANDING_ROUTES.CREATIVE_STRATEGIST },
            { label: 'Static & Video Ads', href: PUBLIC_LANDING_ROUTES.STATIC_VIDEO_ADS },
            { label: 'Media Buying', href: PUBLIC_LANDING_ROUTES.MEDIA_BUYING },
            { label: 'Analysis', href: PUBLIC_LANDING_ROUTES.AD_ANALYSIS },
        ],
    },
    {
        heading: 'By use case',
        items: [
            { label: 'E-Commerce Ads', href: productHref(USER_FACING_PRODUCT_CATEGORIES.E_COMMERCE) },
            { label: 'Mobile Apps Ads', href: productHref(USER_FACING_PRODUCT_CATEGORIES.MOBILE_APP) },
            { label: 'Website Ads', href: productHref(USER_FACING_PRODUCT_CATEGORIES.WEBSITE) },
            { label: 'Static Ads', href: PUBLIC_LANDING_ROUTES.STATIC_ADS },
            { label: 'Agencies & Freelancers', href: PUBLIC_LANDING_ROUTES.AGENCY },
        ],
    },
]

/** Top-level nav links shown beside Solutions. */
export const PRIMARY_NAV_LINKS: ILandingV3NavItem[] = [
    { label: 'Case Studies', href: PUBLIC_LANDING_ROUTES.CASE_STUDY },
    { label: 'Pricing', href: PUBLIC_LANDING_ROUTES.PRICING },
    { label: 'News', href: PUBLIC_LANDING_ROUTES.NEWS },
]

/*
 * TODO(landing-v3): unlinked pages — decide keep-unlinked / 301-redirect / delete.
 * Dropped from the Solutions menu in this redesign: /lovable, /base44, /formats/ai-ugc-ads,
 * /formats/e-com-assets. Full inventory: docs/landing-v3-unlinked-pages.md.
 */
